import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postPlannerHideColumnsAPI = createApi("PostPlannerHideColumns","POST");

const PostPlannerHideColumns = createSlice({
  name: 'PostPlannerHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postPlannerHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPlannerHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postPlannerHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostPlannerHideColumns.reducer;